angular
	.module 'App.Repository'
	.factory 'AdyenSubscriptionRepository', ['BaseRepository', (BaseRepository) ->
		class AdyenSubscriptionRepository extends BaseRepository
			@resource = '/adyen'
			@isRestricted = true

			subscribe: ->
				return @post 'subscribe'

		return new AdyenSubscriptionRepository
	]
